import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/img/logo.png";
import usericon from "../assets/img/user.png";
import packageJson from "../../package.json";
import { Link, useNavigate } from "react-router-dom";

// Import Bootstrap JS bundle if using npm
import "bootstrap/dist/js/bootstrap.bundle.min";

const BASE_URL = packageJson.apiUrl;
const SITE_URL = packageJson.siteUrl;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [user, setUser] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine); // Online status
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const storedToken = localStorage.getItem("token");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}/category/list`);
        const data = await response.json();
        if (data.success) {
          setCategories(data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedToken) setUser(JSON.parse(storedUser));
  }, [storedToken]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  const handleScroll = () => setIsScrolled(window.scrollY > 50);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  const toggleNavbar = () => setIsCollapsed(!isCollapsed);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const closeNavbar = () => {
    setIsCollapsed(false);
    setDropdownOpen(false);
    const offcanvasEl = document.getElementById("offcanvasRight");
    if (offcanvasEl) {
      const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(offcanvasEl);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <nav className={`navbar navbar-expand-lg m-navbar navbar-light bg-light ${isScrolled ? "scrolled" : ""}`}>
        <div className="container-xl">
          <a className="navbar-brand" href="/" onClick={closeNavbar}>
            <img src={logo} alt="logo" className="img-fluid" />
          </a>
          <button
            className={`navbar-toggler ${isCollapsed ? "" : "collapsed"}`}
            type="button"
            onClick={toggleNavbar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isCollapsed ? "show" : ""}`} id="navbarNav">
            <ul className="navbar-nav me-auto ms-auto">
              <li className="nav-item active">
                <a className="nav-link" href="/" onClick={closeNavbar}>Home</a>
              </li>
              <li className="nav-item nav-item-mob">
                <a className="nav-link" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight">
                  Online Care Courses
                </a>
              </li>
              <li ref={dropdownRef} className={`nav-item nav-item-desk dropdown ${dropdownOpen ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  onClick={toggleDropdown}
                >
                  Online Care Courses
                </a>
                <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                  {categories.map((category) => (
                    <li key={category.id}>
                      <Link
                        className="nav-link featured-title"
                        to={`/category/course/${category.slug}`}
                        onClick={closeNavbar}
                      >
                        {category.category}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <Link className="nav-link featured-title" to="/courses">All Courses</Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about" onClick={closeNavbar}>About Us</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blogs" onClick={closeNavbar}>Blogs</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/courses" onClick={closeNavbar}>Explore Courses</Link>
              </li>
            </ul>

            <ul className="navbar-nav ms-auto ul-right">
              {user ? (
                <>
                  <li className="nav-item my-auto">
                    <Link
                      className="nav-link d-flex align-items-center"
                      to={`${BASE_URL}/user_dashboard?auth=${storedToken}`}
                      onClick={closeNavbar}
                    >
                      {(user.name && user.name.length > 10 ? user.name.slice(0, 10) + "..." : user.name) || "Profile"}
                      <img
                        src={usericon}
                        style={{ borderRadius: "50%" }}
                        className="img-fluid ms-1"
                        width="25"
                        height="25"
                        alt="user"
                      />
                      <span
                        className={`ms-2 badge rounded-pill ${isOnline ? "bg-success" : "bg-danger"}`}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {isOnline ? "Online" : "Offline"}
                      </span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link btn btn-white" onClick={handleLogout}>Logout</button>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link className="nav-link btn btn-white" to="/login" onClick={closeNavbar}>
                      Login
                    </Link>
                  </li>
                  <li className="nav-item nav-green">
                    <Link className="nav-link btn btn-green" to="/register" onClick={closeNavbar}>
                      Sign up
                    </Link>
                  </li>
                </>
              )}
            </ul>

          </div>
        </div>
      </nav>

      <div
        className="offcanvas m-offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">Online Care Courses</h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="canvas-cat list-unstyled">
            {categories.map((category) => (
              <li key={category.id}>
                <Link
                  className="nav-link featured-title"
                  to={`/category/course/${category.id}`}
                  onClick={closeNavbar}
                >
                  {category.category}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
